import SEOMeta from "@/components/SEOMeta";

const CONTACT_EMAIL = "eliveuton.dev@gmail.com";

const PrivacidadeAutomacaoInstagram = () => {
  return (
    // Cor de marca do produto "Automação Instagram" (página avulsa, fora do design system).
    // eslint-disable-next-line no-restricted-syntax
    <div className="flex min-h-screen items-center justify-center bg-[#3B4CB8] px-6 py-16">
      <SEOMeta
        title="Política de Privacidade — Automação Instagram"
        description="Política de privacidade da automação de respostas automáticas no Instagram."
        canonicalUrl="/politica-privacidade-automacao-instagram"
      />

      <div className="w-full max-w-xl space-y-6 text-center text-white">
        <h1 className="text-2xl font-bold md:text-3xl">Política de Privacidade</h1>

        <p className="text-sm leading-relaxed text-white/90 md:text-base">
          Este aplicativo é utilizado exclusivamente para automações internas relacionadas a uma
          conta comercial do Instagram.
        </p>

        <p className="text-sm leading-relaxed text-white/90 md:text-base">
          Os dados acessados (como comentários e mensagens) são utilizados apenas para responder
          interações automaticamente e não são compartilhados com terceiros.
        </p>

        <p className="text-sm leading-relaxed text-white/90 md:text-base">
          Nenhuma informação pessoal é vendida ou distribuída.
        </p>

        <p className="text-sm leading-relaxed text-white/90 md:text-base">
          Em caso de dúvidas, entre em contato pelo e-mail:{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="underline hover:no-underline">
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </div>
  );
};

export default PrivacidadeAutomacaoInstagram;
